var _defs, _path, _ellipse, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElement3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.5 121.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9472;}.cls-2,.cls-4{fill:#7b02f3;}.cls-3{fill:#f618f7;}.cls-4{opacity:0.11;}.cls-5{fill:#083a49;opacity:0.19;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.6,52.11l20.52-4.66"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 100.1,
    cy: 37.4,
    rx: 29.15,
    ry: 56.32,
    transform: "translate(18.73 106.67) rotate(-60.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.22,117.43c15.47,4,25.32,4.09,29.91,4.08,4.24,0,37.05-.49,33-20.1-4.41-21.52-51.07-55.6-93.85-74.13C61.79,13.64,17.32,1.92,3.78,14.66-10.65,28.23,19.25,61,50.24,82.41,54.19,85.14,87.51,107.89,124.22,117.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.33,107a90.24,90.24,0,0,0,24.26,3.3c3.44,0,30-.39,26.79-16.29C164.81,76.49,127,48.85,92.26,33.83,66.7,22.76,30.63,13.26,19.65,23.59c-11.71,11,12.54,37.55,37.68,55C60.53,80.76,87.56,99.21,117.33,107Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.89,39.05c5.45,7.89,12.4,29.15,33.58,21.46,10.26-3.74,26.1-11.39,51.3,0,160,72.28,54.23,2.79,58.29-4.2,5.9-10.16-2.59-18.63-25.65-35.91C108.76,8.67,70.57-5,58.65,5,37.81,22.5,10,16.63,8.29,14.34,5,9.77,2,32,6.89,39.05Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.65,11.58C48.52,23.93,82.38,28.93,97.9,29.3s26.27-1.81,30.73-.37c22.42,7.23-16.09-19.54-41.06-27.17C72.91-2.72,53.87,2.84,51.65,11.58Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.53,49.68c3.1,3.6-4.94-26.22,13.77-30.54C43.88,15.31,51,14.82,51.16,13.78c.44-2.32-40-8-47.59,1.78C.16,20-5.67,27.45,13.53,49.68Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement3);
export default __webpack_public_path__ + "static/media/Element3.8bfb31933ac7ffdd2bfa36e1f8c64d18.svg";
export { ForwardRef as ReactComponent };